import { useScope } from '../../app/scope';
import { AppLink, Badge, Notice, PageHeader, Panel } from '../../shared/ui/primitives';
import { Icon as SharedIcon } from '../../shared/ui/Icon';

export function BuyerHotelsPage() {
    const { data, href } = useScope();
    return <>
        <PageHeader eyebrow="BUYER WORKSPACE · SUPPLIER CATALOG" title="Available hotels" description="Browse fictional Aruba supply before searching dates and contracted rates." />
        <Notice>Seller workspace controls property content, inventory and rates. Buyer workspace can browse the sample catalog and book eligible supply.</Notice>
        <div className="property-grid">
            {data.properties.map(property => {
                const rooms = data.rooms.filter(room => room.property_id === property.id);
                return <Panel key={property.id} className="property-card">
                    <div className={`property-illustration illustration-${property.id}`}><SharedIcon name="building" size={56} /><Badge tone="info" dot={false}>Buyer supply</Badge></div>
                    <div className="padded"><span className="eyebrow">{property.area}</span><h2>{property.name}</h2><p>{property.description}</p><div className="property-card-footer"><span>{rooms.length} room types · {property.currency}</span><AppLink className="text-link" href={href('/search', { property: property.id })}>Search dates<SharedIcon name="arrow" size={16} /></AppLink></div></div>
                </Panel>;
            })}
        </div>
        <Notice tone="warning">These properties are fictional sample supply. No hotel, channel manager or payment provider is connected.</Notice>
    </>;
}
